import React, {useState} from 'react';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {noop} from 'lodash';

import {Banner} from '/component/base/Banner/Banner';
import Button from '/component/base/Button';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {DownlineProfile} from '/constant/TestIDs';
import sharedTestIDs from '/constant/TestIDs/Shared';
import {useTranslation} from '/provider/TranslationProvider';
import {safeLayoutAnimation} from '/util/animation.util';
import testProperties from '/util/testing/testProperties';

import {generateOpenDeletePopover} from '../ProfileAlreadyExistsBanner/ProfileAlreadyExistsBanner.util';

import {styles} from './EmailAlreadyExistsBanner.style';
interface EmailAlreadyExistsBannerProps {
  popoverShow: () => void;
  candidateId: string;
  deleteCandidate: () => void;
}

export const EmailAlreadyExistsBanner: React.FC<
  EmailAlreadyExistsBannerProps
> = ({popoverShow = noop, candidateId = '', deleteCandidate = noop}) => {
  const {ts, tt} = useTranslation('EmailAlreadyExistsBanner');
  const navigation = useNavigation();
  const [expanded, setExpanded] = useState(true);
  const toggleExpand = () => {
    safeLayoutAnimation();
    setExpanded(!expanded);
  };
  const handleDeleteProfile = async () => {
    await deleteCandidate({candidateId});
    navigation.goBack();
  };
  return (
    <View
      style={styles.container}
      {...testProperties(DownlineProfile.mergeBannerRoot)}>
      <Banner style={{base: styles.base}} verticalBanner alertLevel="info">
        <TouchableOpacity
          style={styles.accordionHeader}
          onPress={toggleExpand}
          accessibilityRole="button"
          accessibilityLabel={ts(
            'merge banner toggle',
            'Toggle details for existing candidate',
          )}
          accessibilityState={{expanded}}>
          <Icon name="alert" style={styles.alertButtonIcon} />
          <Text
            isBold
            {...testProperties(DownlineProfile.mergeBannerHeader)}
            style={styles.bannerText}>
            {ts(
              'Accordion Title',
              'Candidate already exists in another organization',
            )}
          </Text>
          <Icon
            name={expanded ? 'chevron-up' : 'chevron-down'}
            style={styles.accordionIcon}
          />
        </TouchableOpacity>
        {expanded && (
          <>
            <Text
              style={styles.accordionBody}
              {...testProperties(DownlineProfile.mergeBannerDescription)}>
              {tt(
                'EmailAlreadyExists',
                'This person may be an active or lapsed Client in another organization. Another account cannot be created using this email.',
              )}
            </Text>
            <Button
              type="textLink"
              accessibilityLabel={ts(
                'delete button',
                'Archive candidate profile',
              )}
              onPress={generateOpenDeletePopover(
                popoverShow,
                handleDeleteProfile,
              )}
              style={{base: styles.btnStyle}}
              {...testProperties(DownlineProfile.mergeBannerArchive)}>
              <View
                style={styles.textStyle}
                {...testProperties(sharedTestIDs.view)}>
                <Icon
                  name={'trash'}
                  style={styles.trashIcon}
                  {...testProperties(DownlineProfile.mergeBannerArchiveIcon)}
                />
                <Text style={styles.removeLabel} isBold>
                  {ts('delete button', 'Archive candidate profile')}
                </Text>
              </View>
            </Button>
          </>
        )}
      </Banner>
    </View>
  );
};

export default EmailAlreadyExistsBanner;
